<template>
  <modal
      name="instructions"
      classes="modal-class"
      :min-width="200"
      :min-height="200"
      @before-open="beforeOpen"
      :scrollable="true"
      :reset="true"
      width="75%"
      height="auto"
  >
    <v-dialog
        @before-opened="dialogEvent('before-open')"
        @before-closed="dialogEvent('before-close')"
        @opened="dialogEvent('opened')"
        @closed="dialogEvent('closed')"
    />
    <div class="size-modal-content">
      <!--<button class="btn btn-submit create-order-button" @click="navToOrder()">Create Your Order</button>-->
      <p style="line-height:115%; font-size:12pt">
        <span style="font-size:12pt">&#xa0;</span>
      </p>
      <p style="line-height:115%; font-size:14pt; text-align: center;">
        <strong><u><span style="font-size:14pt; ">Instructions to Order Ray-Ban Authentic Special Edition Complete Pair</span></u></strong>
      </p>
      <br/>
      <p style="line-height:115%; font-size:14pt">
        <span style="font-size:14pt">In order to have the best experience with your Ray-Ban Complete Pair, please follow these instructions carefully. We have a select choice of bestselling frame models, colors, and sizes and we are unable to offer any substitutions at this time.</span>
      </p>
      <br/>
      <p style="margin-left:36pt; text-indent:-18pt; line-height:115%; font-size:10pt;">
        <span style="font-size:12pt; text-decoration:none">●</span><span style="font-size:10pt; margin-left: 11pt">Collect your Rx Information, make sure it is accurate, if you do not have a prescription please order an Eyezen Start with 0 prescription</span>
      </p>
      <p style="margin-left:36pt; text-indent:-18pt; line-height:115%; font-size:11pt;">
        <span style="font-size:12pt; text-decoration:none">●</span><span style="font-size:10pt; margin-left: 11pt">Review the frame assortment <a style="color:#1155cc" target="_blank" href="https://api.essilorevaluationunit.com/RB-%20AE%20Samples%20Assortment.pdf"><u style="font-size:10pt; color:#1155cc">here</u></a> and select your frame. Please do not wait until the last minute, as you’ll have to choose a frame online and also provide the PD* and Fitting Height** measurements to complete the trial eyewear ordering. Frame supplies are limited and will be first-come, first-served! Have a second and third choice in mind in case the first is sold out.</span>
      </p>
      <p style="margin-left:36pt; text-indent:-18pt; line-height:115%; font-size:10pt;">
        <span style="font-size:12pt; text-decoration:none">●</span><span style="font-size:10pt; margin-left: 11pt">Try on your chosen frame at a retail/optical store and ensure that the frame you are trying on is the same size as listed on the catalog to get accurate measurements</span>
      </p>
      <p style="margin-left:36pt; text-indent:-18pt; line-height:115%; font-size:10pt;">
        <span style="font-size:12pt; text-decoration:none">●</span><span style="font-size:10pt; margin-left: 11pt">Get your frame measurements: PD and fitting height (mandatory for PAL wearers) </span>
      </p>
      <p style="margin-left:36pt; text-indent:-18pt; line-height:115%; font-size:10pt;">
        <span style="font-size:12pt; text-decoration:none">●</span><span style="font-size:10pt; margin-left: 11pt">Order your complete pair and review your order for Rx information, frame and measurement</span>
      </p>
      <br/>
      <p style="line-height:138%; font-size:10pt;">
        <span style="font-size:10pt">USEFUL TIP - You could get your frame measurements at one of your trusted account practices. </span>
      </p>
      <br/>
      <p style="line-height:115%; font-size:12pt">
        <span style="font-size:12pt">*Pupillary Distance (PD) is the distance between the pupils. </span>
      </p>
      <p style="line-height:115%; font-size:12pt">
        <span style="font-size:12pt">**Fitting Height measures from the center of the pupil to the bottom of the lens for each eye. </span>
      </p>
      <p>
        &#xa0;
      </p>
      <p style="line-height:115%; font-size:12pt">
        <img src="/images/frame.png" width="641" height="233" alt="" />
      </p>
      <p style="line-height:115%; font-size:12pt">
        <span style="font-size:12pt">*There are a few apps and online tools available to help you self-measure if you can’t access a professional. For example </span><a style="color:#1155cc"  target="_blank" href="https://www.eyebuydirect.com/guides/how-to-measure-your-pd?channel=cpc&amp;source=google&amp;matchtype=b&amp;kw=&amp;adid=445592018849&amp;addisttype=g&amp;gclid=Cj0KCQiA6t6ABhDMARIsAONIYyyI24lTK2cz2WiGoIKwPKOezm_9-Bl0KyC8VtUHcww1Z457ZKWpr3IaAs6uEALw_wcB"><u><span style="font-size:12pt; color:#1155cc">here</span></u></a><span style="font-size:12pt"> or download a PD ruler </span><a style="color:#1155cc" target="_blank" href="http://eyebuydirect.com/downloads/measure-your-pd-with-ruler.pdf"><u><span style="font-size:12pt; color:#1155cc">here</span></u>.</a>
      </p>
      <p style="line-height:115%; font-size:12pt">
        <span style="font-size:12pt">The average Monocular/Distance PD ( ½ PD) value is 28-32mm.</span>
      </p>
      <p style="line-height:115%; font-size:12pt">
        <span style="font-size:12pt">The average fitting height (Eye Height) is between 14-25 mm, this will allow proper room in each part of the lens so that you can see your best, whether you're driving or using your computer.</span>
      </p>
      <p>
        <strong><span style="color:#ff0000;">Please ensure that your prescription and product choice is accurate on the order as redos are only available in cases of processing errors or defects.</span></strong>
      </p>
    </div>
  </modal>
</template>
<script>
import Vue from "vue";

export default {
  props: ["couponCode", "programChoice"],
  name: "SizeModalTest",
  data() {
    return {
      cc: "",
      pc: ""
    }
  },
  methods: {
    beforeOpen(event) {
      this.cc = this.couponCode;
      this.pc = this.programChoice;
    },
    processCode(couponData) {
      if (couponData.programDetails.marketingPageName) {
        axios
            .get(
                Vue.config.HOST_URL + couponData.programDetails.marketingPageName,
                {
                  responseType: "text"
                }
            )
            .then(response => {
              this.marketingContent = response.data;
              this.loaded = true;
            });
      } else {
        this.navToOrder();
      }
    },
    navToOrder() {
      if (this.programChoice) {
        this.$router.push(
            "/order/" + this.cc + "?programChoice=" + this.pc
        );
      } else {
        this.$router.push("/order/" + this.couponCode);
      }
    },
    dialogEvent(eventName) {
      console.log('Dialog event: ' + eventName)
    }
  }
};
</script>

<style>
.size-modal-content {
  padding: 10px;
  font-style: 13px;
  height: 600px;
  overflow-y : scroll;
}
.v--modal-overlay[data-modal='size-modal'] {
  background: rgba(0, 0, 0, 0.5);
}
.modal-class {
  border-radius: 5px;
  background: white;
  box-shadow: 5px 5px 30px 0px rgba(46, 61, 73, 0.6);
}
</style>